import React from 'react';
import { Row, Col } from 'antd';
import moment from 'moment';
import { Text } from '../../../../components/Text';
import { DivItems } from '../../../../components/EditForm/styles';

export default function InfoArrendatarioLeitura({ dadosArrend }) {
  return (
    <Col span={24} style={{ margin: '24px 0' }}>
      {dadosArrend?.pessoaFisicaCadastro?.cpf ? (
        <>
          <Row
            gutter={[2, 8]}
            style={{ marginBottom: '16px' }}
            justify="space-between"
          >
            <Col span={8}>
              <Text
                title="Nome"
                value={dadosArrend?.pessoaFisicaCadastro?.nome || '-'}
              />
            </Col>
            <Col span={8}>
              <Text
                title="CPF"
                value={dadosArrend?.pessoaFisicaCadastro?.cpfFormatado || '-'}
              />
            </Col>
            <Col span={8}>
              <Text
                title="Data de Nascimento"
                value={
                  moment(
                    dadosArrend?.pessoaFisicaCadastro?.dataNascimento
                  ).format('DD/MM/YYYY') || '-'
                }
              />
            </Col>
          </Row>
          <Row
            gutter={[2, 8]}
            style={{ marginBottom: '16px' }}
            justify="space-between"
          >
            <Col span={8}>
              <Text title="Telefone" value={dadosArrend?.telefone || '-'} />
            </Col>
            <Col span={8}>
              <Text
                title="Naturalidade"
                value={dadosArrend?.pessoaFisicaCadastro?.naturalidade || '-'}
              />
            </Col>
            <Col span={8}>
              <Text
                title="Nome da mãe"
                value={dadosArrend?.pessoaFisicaCadastro?.nomeMae || '-'}
              />
            </Col>
          </Row>
          <Row
            gutter={[2, 8]}
            style={{ marginBottom: '16px' }}
            justify="space-between"
          >
            <Col span={8}>
              <Text
                title="Nome do pai"
                value={dadosArrend?.pessoaFisicaCadastro?.nomePai || '-'}
              />
            </Col>
            <Col span={8}>
              <Text
                title="Numero do PIS"
                value={dadosArrend?.pessoaFisicaCadastro?.numeroPIS || '-'}
              />
            </Col>
            <Col span={8}>
              <Text
                title="Numero do RG"
                value={dadosArrend?.pessoaFisicaCadastro?.numeroRG || '-'}
              />
            </Col>
          </Row>
          <Row
            gutter={[2, 8]}
            style={{ marginBottom: '16px' }}
            justify="space-between"
          >
            <Col span={8}>
              <Text title="Endereço" value={dadosArrend?.endereco || '-'} />
            </Col>
            <Col span={8}>
              <Text
                title="UF RG"
                value={dadosArrend?.pessoaFisicaCadastro?.ufrg || '-'}
              />
            </Col>
          </Row>
          <Row gutter={[2, 8]} style={{ marginBottom: '16px' }} justify="start">
            <Col span={8}>
              <Text title="Documento" value={dadosArrend?.documento || '-'} />
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Row
            gutter={[2, 8]}
            style={{ marginBottom: '16px' }}
            justify="space-between"
          >
            <Col span={8}>
              <Text
                title="Nome Fantasia"
                value={dadosArrend?.pessoaJuridicaCadastro?.nomeFantasia || '-'}
              />
            </Col>
            <Col span={8}>
              <Text
                title="Razão social"
                value={dadosArrend?.pessoaJuridicaCadastro?.razaoSocial || '-'}
              />
            </Col>
            <Col span={8}>
              <Text
                title="Inscrição estadual"
                value={
                  dadosArrend?.pessoaJuridicaCadastro?.inscricaoEstadual || '-'
                }
              />
            </Col>
          </Row>
          <Row
            gutter={[2, 8]}
            style={{ marginBottom: '16px' }}
            justify="space-between"
          >
            <Col span={8}>
              <Text
                title="CNPJ"
                value={
                  dadosArrend?.pessoaJuridicaCadastro?.cnpjFormatado || '-'
                }
              />
            </Col>
            <Col span={8}>
              <Text title="Documento" value={dadosArrend?.documento || '-'} />
            </Col>
            <Col span={8}>
              <Text title="Telefone" value={dadosArrend?.telefone || '-'} />
            </Col>
          </Row>
          <Row
            gutter={[2, 8]}
            style={{ marginBottom: '16px' }}
            justify="space-between"
          >
            <Col span={16}>
              <Text title="Endereço" value={dadosArrend?.endereco || '-'} />
            </Col>
          </Row>
        </>
      )}
    </Col>
  );
}
